import React from 'react';
import TransportHomePage from './TransportHomePage.jsx';
var axios = require('axios');
var constants = require("../constants/constants");

export default class KarkhanaList_details_Information extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iskarkhanaDetails: false,
      karkhanaDetails: false,
      isUserprofile: false,
      caneInformation: [],
      TransporterInfo: [],
    };
  }

  componentWillMount() {
    var user = JSON.parse(sessionStorage.getItem("User"));
    let currentComponent = this;
    axios.get(constants.config.HOST + constants.api.GET_TRANSPORTER_INFORMATION, {
      params: { TransportersId: user.TransportersId, YearId: user.TargetYearId, CompanyId: localStorage.getItem('CompanyId') || 1, Action: 'Mukadam' }
    }).then(function (response) {
      currentComponent.setState({ TransporterInfo: response.data })
      console.log(response.data)
    }).catch(function (error) {
      console.log(error);
    });
  }

  karkhanaDetails(e, CompanyId) {
    this.setState({
      iskarkhanaDetails: true,
    });
    localStorage.setItem('CompanyId', CompanyId);
    this.props.history.push({
      pathname: '/TransportHomePage',
      CompanyId: CompanyId,
    })
  }

  PasswordInfo(e) {
    this.setState({
      isUserprofile: true,
    });
  }

  handleInputChange(e) {
    e.preventDefault();
    var name = e.target.name;
    var state = this.state;
    state[name] = e.target.value;
    this.setState(state);
  }

  render() {
    let currentComponent = this;
    let vehicleList = '';
    return (
      <div class="pages">
        <div data-page="form" class="page no-toolbar no-navbar">
          <div class="page-content">
            <div class="navbarpages navbarpagesbg">
              <div class="navbar_left">
                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
              </div>
              <div class="navbar_right">
                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
              </div>
            </div>
            <div id="pages_maincontent">
              <div>
                {
                  (this.state.TransporterInfo !== null || this.state.TransporterInfo !== undefined) ?
                    this.state.TransporterInfo.map(function (Transporter, index) {
                      return (
                        <h>
                          <div className="card ">
                            {
                              Transporter.VehicleName.split(',').map(function (vName, index) {
                                vehicleList += vName + '(' + Transporter.VehicleCount.split(',')[index] + ')';
                              })}
                            <p style={{ 'color': '#1900ff' }}> <b>कारखान्याचे नाव : </b><b style={{ 'color': '#0099FF' }}>{Transporter.CompanyName}</b></p>
                            <p style={{ 'color': '#1900ff' }}>   <b>वाहने : </b> <b style={{ 'color': '#0099FF' }}>{vehicleList}</b></p>
                            <p style={{ 'color': '#1900ff' }}>  <b> मुकादम : </b><b style={{ 'color': '#0099FF' }}>{Transporter.TotalMukadam}</b></p>
                            <p style={{ 'color': '#1900ff' }}>  <b> उसतोडणी कामगार :</b>  <b style={{ 'color': '#0099FF' }}>{Transporter.TotalKamgar}</b></p>
                            <p><button type="submit" class="btn  btn-primary " style={{ padding: '10px 15px 10px 10px', margin: '10px 0px 0px 200px' }}
                              onClick={(e) => { currentComponent.karkhanaDetails(e, Transporter.CompanyId) }}>माहिती भरा </button>
                            </p>
                          </div>
                        </h>
                      )
                    })
                    : ''
                }
              </div>
              <div>
                {this.state.iskarkhanaDetails ?
                  <TransportHomePage /> :
                  null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/KarkhanaList_details_Information.jsx